import { motion } from 'framer-motion';
import { LogIn, ChevronRight } from 'lucide-react';
import { useState, useEffect } from 'react';

const LAPTOP_IMG = 'https://customer-assets.emergentagent.com/job_acella-onboard-flow/artifacts/hydy6axn_sign%20in%20email%20%2C%20.jpg';

export default function NewUserSignInScene({ onNext }) {
  const [email, setEmail] = useState('');
  const target = 'abdulahmed@xyz.com';

  useEffect(() => {
    const timers = [];
    for (let i = 0; i <= target.length; i++) {
      timers.push(setTimeout(() => setEmail(target.slice(0, i)), 1200 + i * 60));
    }
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div data-testid="scene-new-user-signin" className="flex flex-col items-center justify-center h-full px-8">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="w-full max-w-3xl">
        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-6">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-body font-medium bg-teal-600/10 text-teal-700 mb-3">
            <LogIn size={14} /> New User Flow
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-[#0A0A0A]">Sign In</h2>
          <p className="mt-2 font-body text-base text-[#737373]">User enters their email to access Shafafiya</p>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.15 }}
          className="text-[12px] font-body text-[#737373] mb-4">
          Home <ChevronRight size={12} className="inline" /> <span className="font-medium text-[#0A0A0A]">Sign-in</span>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 20, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="bg-white rounded-2xl border border-black/5 shadow-2xl overflow-hidden flex"
        >
          {/* Form side */}
          <div className="flex-1 p-10 flex flex-col justify-center">
            <motion.h3 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}
              className="font-heading font-medium text-2xl text-[#0A0A0A] mb-6">
              Welcome to Shafafiya
            </motion.h3>

            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.7 }}>
              <label className="text-sm font-body font-bold text-[#0A0A0A] mb-2 block">Email</label>
              <div className="w-full px-4 py-3 rounded-lg border border-[#E5E7EB] bg-white text-sm font-body text-[#0A0A0A] mb-5 min-h-[44px]">
                {email || <span className="text-[#737373]">Enter your email address</span>}
                {email.length < target.length && email.length > 0 && <span className="inline-block w-0.5 h-4 bg-teal-600 animate-pulse ml-0.5 align-middle" />}
              </div>
            </motion.div>

            <motion.button
              initial={{ opacity: 0 }}
              animate={{ opacity: email === target ? 1 : 0.5 }}
              transition={{ delay: 0.9 }}
              className="w-full py-3 rounded-lg bg-teal-600 text-white font-body font-bold text-sm cursor-pointer"
              onClick={onNext}
            >
              Continue
            </motion.button>
          </div>

          {/* Image side - cropped from user's screenshot */}
          <div className="w-[320px] flex-shrink-0 hidden md:block overflow-hidden">
            <img src={LAPTOP_IMG} alt="Sign in" className="w-full h-full object-cover object-[85%_center]" style={{ transform: 'scale(2.2)' }} />
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}
